import Navbar from '@/components/feature/Navbar';
import HomeSchema from '@/components/feature/HomeSchema';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import SeoIntroSection from './components/SeoIntroSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <main>
      <HomeSchema />
      <Navbar />
      <HeroSection />
      <CategorySection />
      <SeoIntroSection />
      <Footer />
    </main>
  );
}